// src/context/AutomationContext.tsx
import { createContext } from 'react';
import { Automation } from '@/types/automations.ts';

export const AutomationContext = createContext<Automation | null>(null);

// export function AutomationProvider({
//   automation,
//   children,
// }: {
//   automation: Automation;
//   children: React.ReactNode;
// }) {
//   return <AutomationContext.Provider value={automation}>{children}</AutomationContext.Provider>;
// }

// export function useAutomation(): Automation {
//   const ctx = useContext(AutomationContext);
//   if (!ctx) {
//     throw new Error('useAutomation must be used within AutomationProvider');
//   }
//   return ctx;
// }
